import React from 'react';
import { Input } from '../../../../../UI/Common';

const ShapeCommonPropertiesForm = ({
  values: { position, dimension, ...values },
  handleChange,
  setFieldValue,
  touched,
  errors,
  ...props
}) => {
  return (
    <>
      <Input
        id="name"
        label="Name"
        onChange={handleChange('name')}
        value={values.name}
        invalid={touched.name}
        error={errors.name}
      />
      <div className="d-flex flex-row">
        <Input
          id="position.left"
          type="number"
          label="X"
          onChange={handleChange('position.left')}
          onFocus={(e) => e.target.select()}
          value={position.left}
          invalid={touched.position && touched.position['left']}
          error={errors.position && errors.position['left']}
        />
        <Input
          id="position.top"
          type="number"
          label="Y"
          onChange={handleChange('position.top')}
          onFocus={(e) => e.target.select()}
          value={position.top}
          invalid={touched.position && touched.position['top']}
          error={errors.position && errors.position['top']}
        />
      </div>
      <div className="d-flex flex-row">
        <Input
          id="dimension.width"
          type="number"
          label="Width"
          onChange={(e) =>
            setFieldValue('dimension.width', e.target.valueAsNumber)
          }
          onFocus={(e) => e.target.select()}
          value={dimension.width}
          invalid={touched.dimension && touched.dimension['width']}
          error={errors.dimension && errors.dimension['width']}
        />
        <Input
          id="dimension.height"
          type="number"
          label="Height"
          onChange={(e) =>
            setFieldValue('dimension.height', e.target.valueAsNumber)
          }
          onFocus={(e) => e.target.select()}
          value={dimension.height}
          invalid={touched.dimension && touched.dimension['height']}
          error={errors.dimension && errors.dimension['height']}
        />
      </div>
    </>
  );
};

export default ShapeCommonPropertiesForm;
